import React, { useEffect, useState} from 'react';
import {changePageTitle} from 'app/actions/AppActions';
import {THIRTY_MINUTES_INTERVAL} from 'app/constants/SettingsConstants';
import {getBusinessDay, getWithNewDesign} from 'app/selectors/AppSelectors';
import Menu from 'app/containers/MenuContainer';
import Spinner from 'app/components/SpinnerComponent';
import NoSeanses from 'app/components/NoSeancesComponent';
import DailySeancesSeveralCinemas from 'app/containers/Seances/DailySeancesSeveralCinemasContainer';
import DailySeancesSingleCinema from 'app/containers/Seances/DailySeancesSingleCinemaContainer';
import DailySeancesErrorContainer from 'app/containers/errors/DailySeancesErrorContainer';
import {formatMoment, getDateFromSearch, setYaReachGoal} from 'app/selectors/Helpers';
import { useLocation, useParams } from 'react-router';
import { Moment } from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
	getSelectedDay,
	getCurrentCityId,
	getIsSeveralCinemasInCity,
	getCurrentCinemas,
} from 'app/selectors/AppSelectors';
import {getSeanceDates} from 'app/selectors/AfishaSelectors';
import {
	getIsFetching,
	getPreparedDailySeances,
} from 'app/selectors/DailySeancesSelectors';
import { getAfishaInfo } from 'app/actions/AfishaActions';
import getDailySeancesRequest from 'app/actions/DailySeancesActions';
import {setSelectedDay} from 'app/actions/AppActions';
import { setCurrentFiltersPage } from 'app/modules/filters/redux/actions';
import { FiltersPage } from 'app/modules/filters/types';
import FiltersWrapper from "app/modules/filters/components/FiltersWrapper";

const DailySeancesComponent = ({
	page
}: {page: string}) => {
	const dispatch = useDispatch();

	const {search} = useLocation();
	const {cinemaId} = useParams<{cinemaId: string}>();

	const withNewDesign = useSelector(getWithNewDesign);
	const seanceDates = useSelector(getSeanceDates);
	const selectedDay = useSelector(getSelectedDay);
	const isFetching = useSelector(getIsFetching);
	const preparedDailySeances = useSelector(getPreparedDailySeances);
	const cityId  = useSelector(getCurrentCityId);
	const currentCinemas = useSelector(getCurrentCinemas) as any[];
	const isSeveralCinemasInCity = useSelector(getIsSeveralCinemasInCity);
	const isCinemasSeansesPage = page === 'cinemas-seances';

	const [cinemaFilterValue, setCinemaFilterValue] = useState('');

	useEffect(() => {
		let calculatedDate: Moment | null | string  = null;

		if (cinemaId) {
			calculatedDate = getBusinessDay();

			dispatch(setSelectedDay(calculatedDate));

			calculatedDate = formatMoment(calculatedDate);
		} else if (search) {
			calculatedDate = getDateFromSearch(search);

			if (calculatedDate) {
				dispatch(setSelectedDay(moment(calculatedDate)));
			}
		}
		const trueDay = calculatedDate || formatMoment(selectedDay as any);
		const menuItem = document.querySelector<HTMLDivElement>('.menu--date .menu__item--active');

		if (cityId) {
			dispatch(getDailySeancesRequest(trueDay, cityId, cinemaId));
			dispatch(getAfishaInfo(cityId, cinemaId));
		}

		const intervalId = setInterval(() => {
			const date = menuItem
				? formatMoment(moment(menuItem.dataset.date || {}))
				: trueDay;

			dispatch(getDailySeancesRequest(date, cityId, cinemaId));
			dispatch(getAfishaInfo(cityId, cinemaId));
		}, THIRTY_MINUTES_INTERVAL);

		changePageTitle(i18n.t('Seances'));

		return () => {
			clearInterval(intervalId);
		};
	}, [cityId, cinemaId]);

	useEffect(() => {
		if (cinemaId) {
			dispatch(setCurrentFiltersPage(FiltersPage.CINEMA_DAILY_SEANCES));
		} else {
			dispatch(setCurrentFiltersPage(FiltersPage.DAILY_SEANCES));
		}

		setYaReachGoal('open-seances', {section: page});
	}, []);

	const handleChangeDate = (date) => {
		dispatch(getDailySeancesRequest(date, cityId, cinemaId));
	};

	const renderDailySeances = (isSeveralCinemas, seancesData) => {
		if (!seancesData.length) return <NoSeanses />;

		if (isSeveralCinemas && !cinemaId) {
			return (
				<>
					{!withNewDesign && <div className="container daily-seances-list__filter-container">
						<span>{i18n.t('Cinema')}:</span>
						<div className="daily-seances-list__select-wrapper">
							<select
								onChange={(event) => {
									setCinemaFilterValue(event.target.value);
								}}
							>
								<option value={''}>{i18n.t('NotSelected')}</option>
								{
									currentCinemas.map(({id, title}) => (
										<option selected={+cinemaFilterValue === id} key={id} value={id}>{title}</option>
									))
								}
							</select>
						</div>
					</div>}
					<DailySeancesSeveralCinemas filterValue={cinemaFilterValue} />
				</>
			);
		}

		return (
			<div className="container">
				<DailySeancesSingleCinema />
			</div>
		);
	};

	return (
		<DailySeancesErrorContainer>
			<div className="page">
				{!isCinemasSeansesPage
					? <FiltersWrapper onDateChange={handleChangeDate} seanceDates={seanceDates} isDisabled={isFetching} />
					: null}
				{!withNewDesign && <Menu.Calendar
					seanceDates={seanceDates}
					onClick={handleChangeDate}
				/>}
				<div className="daily-seances-list">
					{isFetching
						? <Spinner />
						: renderDailySeances(isSeveralCinemasInCity, preparedDailySeances)
					}
				</div>
			</div>
		</DailySeancesErrorContainer>
	);
};

export default DailySeancesComponent;
